import React from 'react';

const Faqs = () => {
  return <h2>FAQs</h2>;
};

export default Faqs;
